import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useStickifiedContextData } from '~/modules/sticky-product-traits/composables/useStickifiedContextData';

const LATCHKEY_STORE = 'latchkeyStore';

/**
 * @description Store Factory for Latchkey Store.
 * Generates a unique store instance if an ID is provided, allowing for multiple instances (e.g. main product vs sticky ATB).
 */
const useLatchkeyStore = () => {
  const storeName = useStickifiedContextData().getStickifiedContextName<string>(LATCHKEY_STORE);

  return defineStore(storeName, () => {
    const initialized = ref<boolean>(false);
    const selectedLatchkey = ref<string>('');
    const previousSelectedLatchkey = ref<string>('');
    const firstUpcIdForSelectedLatchkey = ref<number | ''>('');

    return {
      initialized,
      selectedLatchkey,
      previousSelectedLatchkey,
      firstUpcIdForSelectedLatchkey,
    };
  })();
};

export default useLatchkeyStore;
